/**
 * SmartAds — Deferred Section Loader
 * Uses IntersectionObserver to lazy-load below-fold PDP sections.
 * Sections with class `sa-deferred-section` get observed.
 * Once in viewport (+ rootMargin), they receive `is-loaded` class
 * which triggers their CSS fade-in animation.
 */
(() => {
  if (!('IntersectionObserver' in window)) {
    /* Fallback: just show everything immediately */
    document.querySelectorAll('.sa-deferred-section').forEach((el) => {
      el.classList.add('is-loaded');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-loaded');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '150px 0px',
      threshold: 0.01,
    }
  );

  const init = () => {
    document.querySelectorAll('.sa-deferred-section').forEach((el) => {
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
